<template>
  <div>
    <!-- header area -->
    <div class="content no-top-padding header-area">
      <div class="title">
        <h1>Device Doughnot Charts</h1>
      </div>
    </div>

    <!-- footer area -->
    <div class="footer-area">
      <div class="content pie-charts">
        <div>
          <custom-pie-chart
            :loading="loadingChartData"
            :data="powerAvailability"
            @onReady="handleOnChartReady"
          ></custom-pie-chart>
        </div>
        <!-- <div>
          <custom-pie-chart
            :loading="loadingChartData"
            :data="powerAvailability"
            @onReady="handleOnChartReady"
          ></custom-pie-chart>
        </div>
        <div>
          <custom-pie-chart
            :loading="loadingChartData"
            :data="powerAvailability"
            @onReady="handleOnChartReady"
          ></custom-pie-chart>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import customPieChart from "./components/customPieChart";

import Vue from "vue";

import {} from "element-ui";

import { HTTP as IOTHTTP } from "../../../store/actions";
import moment from "moment";

export default {
  data() {
    return {
      loadingChartData: false,
      powerAvailability: {},
      networkAvailability: {},
      energySource: {}
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ])
  },
  components: {
    "custom-pie-chart": customPieChart
  },
  methods: {
    async handleOnChartReady(
      upperLimit = null,
      lowerLimit = null,
      limit = 100
    ) {
      let container = this;
      try {
        container.loadingChartData = true;
        // var inverterId = "411241";
        var headers = {
          "Content-Type": "application/plain"
        };

        const data = {
          TableName: "HourlyChart",
          KeyConditionExpression:
            "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
          ExpressionAttributeValues: {
            ":key": `${this.$route.params.deviceId}`,
            ":up": upperLimit || moment().subtract("7", "days"),
            ":down": lowerLimit || new Date().toISOString()
          },
          Limit: 1440, //1440
          ScanIndexForward: true
        };

        const resp = await IOTHTTP.post(`/devicedata`, data, {
          headers
        });

        const DevData = resp.data.Items;

        const lastItemData = DevData[DevData.length - 1];

        this.powerAvailability = {
          title: "Last 24 hours",
          data: [
            {
              value: this.computeData(lastItemData, 'pvSource'),
              name: "PV Source",
              itemStyle: {
                color: "rgba(16, 156, 241,0.4)" // blue
              }
            },
            {
              value: this.computeData(lastItemData, 'gridSource'),
              name: "Grid Source",
              itemStyle: {
                color: "rgba(255, 185, 70,0.47)" // yellow
              }
            },
            {
              value: this.computeData(lastItemData, 'batterySource'),
              name: "Battery Source",
              itemStyle: {
                color: "rgba(250, 113, 111, 0.46)" // red
              }
            }
          ]
        };
        container.loadingChartData = false;
      } catch (error) {
        console.log("********************************************************");
        console.log(error);
        container.loadingChartData = false;
        console.log("********************************************************");
      }
      // this.batteryChart(DevData, this.getTimeLabel(DevData));
    },

    // computeData(arrData, key) {
    //   return arrData.map(item => {
    //     if(!item["loadEnergySource"] || !item["EnergyData"][key]) return
    //     return item["loadEnergySource"][key] / 1000 + 'kVA';
    //   });
    // },

    computeData(objData, key) {
      console.log(objData["loadEnergySource"][key])
      // if(!objData["loadEnergySource"] || !objData["loadEnergySource"][key]) return
      return objData["loadEnergySource"][key];
    },
  },
  mounted() {
    this.inverterId = this.$route.params.deviceId;
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 50px;
}

.footer-area {
  // background-color: #ffffff;
}

.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  // padding: 50px 0;
}

.no-top-padding {
  padding-top: 0;
}

.pie-charts {
  display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/pie.vue